import React from 'react';
import { Container, Jumbotron } from 'reactstrap';

export const Helpdesk: React.FC = () => {
  return (
    <Jumbotron className="mb-4">
      <Container className="p-4" fluid>
        <div className="px-0 px-md-5">
        <h1>Helpdesk</h1>
        <p>Sollten Sie zu den Funktionalitäten der Parametercodierung Fragen haben oder sollten bei der Anwendung Probleme auftreten, steht für Sie ein Helpdesk bereit:</p>
        <p>E-Mail: <a href="mailto:h2o-helpdesk@umweltbundesamt.at">h2o-helpdesk@umweltbundesamt.at</a></p>
        <p>Telefon: +43-(0)1-313 04/8008</p>
      </div>
      </Container>
    </Jumbotron>
  );
};
